/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Auth from '../../utils/Auth';
import PropertyAdminLayout from '../layout/propertyAdmin/PropertyAdminLayout';

export default (props) => (
  <>
    {Auth.isAuthenticated(['propertyAdmin']) ? (
      <PropertyAdminLayout>
        <Route {...props} />
      </PropertyAdminLayout>
    ) : (
      <Redirect to="/" />
    )}
  </>
);
